import { render, staticRenderFns } from "./figuresIncomeStatementsSettings.vue?vue&type=template&id=d23c14c0"
import script from "./figuresIncomeStatementsSettings.vue?vue&type=script&lang=js"
export * from "./figuresIncomeStatementsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports